import { useEffect, useState } from "react";
import { useAssessmentSession } from "../contexts/assessmentUserContext";
import { fetchGrades, GradeOption } from "../services/appGradeService";

export function usePredefinedGradesFilter() {
  const { token } = useAssessmentSession();
  const [grades, setGrades] = useState<GradeOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setGrades([]);
      setError(null);
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    const loadGrades = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const nextGrades = await fetchGrades(token);
        if (!cancelled) {
          setGrades(nextGrades);
        }
      } catch (loadError: unknown) {
        if (!cancelled) {
          setGrades([]);
          setError(
            loadError instanceof Error
              ? loadError.message
              : "Unable to load grades.",
          );
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    loadGrades().then();

    return () => {
      cancelled = true;
    };
  }, [token]);

  return { grades, isLoading, error };
}
